import React, { useEffect, useState } from "react";
import "./TeamRun.scss";
import { Dialog } from "primereact/dialog";
import SharedFlow from "../../../../../../shared/widgets/ReactFlow/ReactFlow";
import { Edge } from "reactflow";
import { INode } from "../../../../../../shared/widgets/ReactFlow/models/node.model";
import { IEdge } from "../../../../../../shared/widgets/ReactFlow/models/edge.model";
import { Button } from "primereact/button";
import SharedForm from "../../../../../../shared/widgets/Form/Form";
import { TypeEnum } from "../../../../../../shared/widgets/Form/enums/TypeEnum";

export default function TeamRun({
  selectedTeam,
  handleRunTeam,
  setIsNewRunOpen,
}: {
  selectedTeam: {
    name: string;
    agents: any[];
  };
  handleRunTeam: any;
  setIsNewRunOpen: any;
}) {
  const [agentNodes, setAgentNodes] = useState<{
    nodes: INode[];
    edges: Edge[];
  }>({ nodes: [], edges: [] });

  const handleFormDataChange = (changedNodes: INode[]) => {
    console.log(changedNodes);
  };

  useEffect(() => {
    const renderedWorkFlow: {
      nodes: INode[];
      edges: IEdge[];
    } = {
      nodes: [],
      edges: [],
    };
    if (selectedTeam) {
      let index = 0;
      selectedTeam.agents.forEach((team, i: number) => {
        if (team.agentFormData.flow) {
          team.agentFormData.flow.nodes.forEach((node: INode) => {
            renderedWorkFlow.nodes.push({
              ...node,
              data: { ...node.data, isRunMode: true },
              id: index.toString(),
              position: { x: 260, y: index * 100 },
            });
            renderedWorkFlow.edges.push({
              id: `e${index}-${index + 1}`,
              source: index.toString(),
              target: (index + 1).toString(),
              type: "smoothstep",
            });
            index++;
          });
        }
      });
    }
    setTimeout(() => {
      setAgentNodes(renderedWorkFlow);
    }, 500);
  }, [selectedTeam]);

  return (
    <Dialog
      header="Run Team"
      visible={true}
      draggable={false}
      style={{ width: "80vw", height: "80vh" }}
      onHide={() => {
        handleRunTeam();
      }}
    >
      <div className="run-agent">
        <div className="run-flow">
          {agentNodes.nodes.length > 0 && (
            <SharedFlow
              nodeProps={agentNodes}
              maxZoom={2}
              handleChangedNodes={(v: any) => handleFormDataChange(v)}
            />
          )}
        </div>
        <div className="config-form">
          {agentNodes.nodes.length > 0 &&
            agentNodes.nodes.map((item, i) => {
              return (
                <div className="node-form" key={i}>
                  <div className="node-title">
                    <h4>{item.data.title}</h4>
                  </div>

                  <div className="shared-node-form">
                    <div className="shared-input-node-form">
                      <p className="input-header">Input</p>
                      {item.data.formData.input.length > 0 && (
                        <SharedForm
                          form={item.data.formData.input.map(
                            (inputItem: any) => {
                              return {
                                label: inputItem.key,
                                field: inputItem.key,
                                value: inputItem.value,
                                type: inputItem.type,
                                options: [
                                  { label: "Text", value: TypeEnum.Input },
                                  { label: "Select", value: TypeEnum.Dropdown },
                                  { label: "Boolean", value: TypeEnum.Switch },
                                ],
                              };
                            }
                          )}
                          setForm={() => {}}
                        />
                      )}
                    </div>
                    <div className="shared-output-node-form">
                      <p className="input-header">Output</p>
                      {item.data.formData.output && (
                        <SharedForm
                          form={[
                            {
                              label: item.data.formData.output.key,
                              field: item.data.formData.output.key,
                              value: item.data.formData.output.value,
                              type: item.data.formData.output.type,
                              options: [
                                { label: "Text", value: TypeEnum.Input },
                                { label: "Select", value: TypeEnum.Dropdown },
                                { label: "Boolean", value: TypeEnum.Switch },
                              ],
                            },
                          ]}
                          setForm={() => {}}
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="actions">
          <Button
            label="Close"
            severity="secondary"
            onClick={() => setIsNewRunOpen(false)}
            outlined
          />
          <Button
            label="Run"
            className="primary"
            onClick={() => handleRunTeam()}
          />
        </div>
      </div>
    </Dialog>
  );
}
